import React from 'react';
import { Folder } from 'lucide-react';

const OverallProjectTasksTable = ({
  overallProjectTasks,
  loadingOverallProjectTasks,
  overallProjectTasksPage,
  overallProjectTasksTotalPages,
  handlePreviousPage,
  handleNextPage,
}) => {
  return (
    <div className="bg-white/80 backdrop-blur-md border border-blue-200 rounded-2xl p-6 shadow-md flex flex-col">
      <h2 className="text-xl font-semibold text-slate-800 mb-6 flex items-center">
        <Folder className="mr-3 text-blue-500" size={24} />
        Overall Project Tasks
      </h2>
      {loadingOverallProjectTasks ? (
        <div className="text-center text-slate-600 py-4">Loading overall project tasks...</div>
      ) : overallProjectTasks.length > 0 ? (
        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-blue-200">
            <thead className="bg-blue-50">
              <tr>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Task Name
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Resource Type
                </th>
                <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-blue-700 uppercase tracking-wider">
                  Actual Completion (%)
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-blue-100">
              {overallProjectTasks.map((task) => (
                <tr key={task.id}>
                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                    {task.milestone ? task.milestone.title : task.task ? task.task.name : 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {task.resource_type || 'N/A'}
                  </td>
                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-600">
                    {typeof task.actual_completion_percent === 'number' ? `${task.actual_completion_percent.toFixed(1)}%` : 'N/A'}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {/* Pagination Controls */}
          <div className="flex justify-end items-center mt-4 space-x-2 text-slate-700">
            <button
              onClick={handlePreviousPage}
              disabled={overallProjectTasksPage === 1}
              className="px-4 py-2 bg-blue-100 rounded-md hover:bg-blue-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            <span className="text-sm font-medium">
              Page {overallProjectTasksPage} of {overallProjectTasksTotalPages}
            </span>
            <button
              onClick={handleNextPage}
              disabled={overallProjectTasksPage === overallProjectTasksTotalPages}
              className="px-4 py-2 bg-blue-100 rounded-md hover:bg-blue-200 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center text-slate-600 py-4">No overall project tasks found based on current filters.</div>
      )}
    </div>
  );
};

export default OverallProjectTasksTable;